import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Button, Grid, Typography, Box } from '@mui/material'

// Theme Components
import Footer from 'src/admin/components/Footer'
import PageTitleWrapper from 'src/admin/components/PageTitleWrapper'
import { Loader } from 'src/admin/components/Loader'
import { SecurityPage } from './SecurityPage'

type PageProps = {
  tabTitle?: string
  pageTitle?: string | React.ReactElement
  pageSubTitle?: string | React.ReactElement
  loading?: boolean
  children: React.ReactElement | React.ReactElement[]
  actions?: React.ReactElement | React.ReactElement[]
  hasAccess?: boolean
}

export const Page = ({ tabTitle, pageTitle, pageSubTitle, actions, loading, hasAccess, children }: PageProps) => {
  // If no title, subtitle, or actions are provided, render a simplified version with just children and footer
  const hasHeader = tabTitle || pageTitle || pageSubTitle || actions
  
  if (!hasHeader) {
    return (
      <SecurityPage hasAccess={hasAccess}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          <Box
            sx={{
              flex: '1 0 auto',
              px: '20px',
              pl: '18px',
              py: 2,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Loader loading={loading}>{children}</Loader>
          </Box>

          <Box sx={{ flex: '0 0 auto' }}>
            <Footer />
          </Box>
        </Box>
      </SecurityPage>
    )
  }

  return (
    <SecurityPage hasAccess={hasAccess}>
      {/* {tabTitle && (
        <Helmet>
          <title>{tabTitle}</title>
        </Helmet>
      )} */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Box sx={{ flex: '0 0 auto' }}>
          <PageTitleWrapper>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                {pageTitle && (
                  <Typography variant="h3" component="h3" gutterBottom>
                    {pageTitle}
                  </Typography>
                )}

                {pageSubTitle && <Typography variant="subtitle2">{pageSubTitle}</Typography>}
              </Grid>
              {actions && <Grid item>{actions}</Grid>}
            </Grid>
          </PageTitleWrapper>
        </Box>

        <Box
          sx={{
            flex: '1 0 auto',
            px: '20px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={2}>
            <Loader loading={loading}>{children}</Loader>
          </Grid>
        </Box>

        <Box sx={{ flex: '0 0 auto' }}>
          <Footer />
        </Box>
      </Box>
    </SecurityPage>
  )
}
